// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  orgId: __t.string().name("org_id"),
  orgName: __t.string().name("org_name"),
  email: __t.string(),
  role: __t.string(),
  invitedByUserId: __t.string().name("invited_by_user_id"),
  invitedByName: __t.string().name("invited_by_name"),
  createdAt: __t.timestamp().name("created_at"),
  expiresAt: __t.timestamp().name("expires_at"),
  status: __t.string(),
  grantTargetKind: __t.string().name("grant_target_kind"),
  grantTargetId: __t.string().name("grant_target_id"),
  grantRole: __t.string().name("grant_role"),
  grantTargetName: __t.string().name("grant_target_name"),
});
